import React from "react";
import { observer } from "mobx-react";
import { useRootAppStore } from "@hooks";
import Slider from "react-slick";

import { MobileSettings } from "@utils/quick-play/slider";
import BetBuilderPicksSliderItem from "./components/BetBuilderPicksSliderItem";

export default observer(function BetBuilderPicksHome() {
	const rootStore = useRootAppStore();

	if (!rootStore.quickPlayStore.betBuilderPicksStore.BBPicks.size) {
		return null;
	}

	return (
		<div className="section--play__body">
			<Slider {...MobileSettings} className="carousel carousel--most">
				{rootStore.quickPlayStore.betBoosterStore.hubData.betBuilderPresetIds.map(
					(item, index) => {
						const slip =
							rootStore.quickPlayStore.betBuilderPicksStore.BBPicks.get(
								item
							);
						if (!slip) {
							return null;
						}
						return (
							<BetBuilderPicksSliderItem
								key={slip.id}
								BBPick={slip}
								index={index}
								activatePopup={
									rootStore.quickPlayStore
										.betBuilderPicksStore.activatePopup
								}
							/>
						);
					}
				)}
			</Slider>
		</div>
	);
});
